import { useState, useCallback } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFaq = useCallback((idx: number) => {
    setOpenIndex((prev) => (prev === idx ? null : idx));
  }, []);

  return (
    <section id="faq" className="w-full py-12 md:py-16 lg:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm font-medium mb-3">
            <i className="ri-question-line"></i>
            <span>答疑解惑</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            常见问答
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl">
            关于香蕉漫画网的收录范围、使用方式与投稿合作的常见问题解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className={`bg-background-50 rounded-xl border transition-all ${
                openIndex === idx ? 'border-primary-300' : 'border-background-200/70'
              }`}
            >
              <button
                type="button"
                className="w-full flex items-center justify-between gap-4 px-4 md:px-6 py-4 text-left"
                onClick={() => toggleFaq(idx)}
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-2">
                  {faq.question}
                </h3>
                <div className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                  openIndex === idx ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-600'
                }`}>
                  <i className={`${openIndex === idx ? 'ri-subtract-line' : 'ri-add-line'} text-sm`}></i>
                </div>
              </button>
              {openIndex === idx && (
                <div className="px-4 md:px-6 pb-4 md:pb-5">
                  <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}